import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

export function usePublicSettings() {
  const [data, setData] = useState(cache?.value || null);
  useEffect(() => {
    if (!cache) cache = { promise: api.get("/settings/public").then((r) => r.data).catch(() => ({})) };
    cache.promise.then((v) => { cache.value = v; setData(v); });
  }, []);
  return data;
}

export function whatsappHref(links) {
  const num = (links?.whatsapp_number || "").replace(/[^\d]/g, "");
  if (!num) return null;
  const msg = links?.whatsapp_message ? `?text=${encodeURIComponent(links.whatsapp_message)}` : "";
  return `https://wa.me/${num}${msg}`;
}
